import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { SessionProvider } from "../../common/context/SessionProvider";
import { ProfileProvider } from "./contexts/ProfileProvider";

// Because of tree-shaking we have to import this manually
import "@glamcorner/components/lib/core/styles/reset.scss";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { RECAPTCHA_KEY } from "../utils/constants";

const BillingPage = lazy(() => import("./pages/BillingPage"));
const BoxHistoryPage = lazy(() => import("./pages/BoxHistoryPage"));
const RenewPage = lazy(() => import("./pages/RenewPage"));
const SuccessPage = lazy(() => import("./pages/SuccessPage"));

const wrapSuspense = (element: React.ReactNode) => <Suspense fallback={<div>Loading...</div>}>{element}</Suspense>;

export default function App() {
  return (
    <SessionProvider>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
        <ProfileProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={wrapSuspense(<BillingPage />)} />
              <Route path="/history" element={wrapSuspense(<BoxHistoryPage />)} />
              <Route path="/renew" element={wrapSuspense(<RenewPage />)} />
              <Route path="/renew/success/:plan_id" element={wrapSuspense(<SuccessPage />)} />
            </Routes>
          </Suspense>
        </ProfileProvider>
      </GoogleReCaptchaProvider>
    </SessionProvider>
  );
}
